// here you put all the js you want.
import { onLoading } from "./js/website";

window.onbeforeunload = function () {
  window.scrollTo(0, 0);
};

document.addEventListener("DOMContentLoaded", () => {
  onLoading();
});
